export default __webpack_public_path__ + "static/media/Majestic Gloves.7406f29a.jpg";